<template>
  <main class="view tracking">
    <header>
      <ul>
        <li />
        <li>
          <a :href="CompanyWebsiteURL()" target="_blank">
            <img class="logo company" :src="CompanyLogoURL()">
          </a>
        </li>
        <li>
          <div id="google_translate_element" />
        </li>
      </ul>
    </header>
    <div class="grid-container">
      <div v-if="ready" class="center-wrapper">
        <div v-if="tracking.success" class="card">
          <div class="card-header">
            <a :href="AgentTrackingSiteURL()" target="_blank">
              <img class="logo agent" :src="AgentLogoURL()">
            </a>
          </div>
          <div :class="['card-body', {reversed: tracking.data.status.error}]">
            <div :class="['row status', {error: tracking.data.status.error, cancelled: tracking.data.status.cancelled, delivered: tracking.data.status.delivered}]">
              <h3>{{ tracking.data.status.message }}</h3>
            </div>
            <div class="row tracking">
              <p>{{ tracking.code }}</p>
            </div>
            <div v-if="!tracking.data.status.error" class="row progress">
              <ul class="steps">
                <li :class="['step', {active: tracking.data.status.registered, checked: tracking.data.status.registered}]">
                  <div class="step-circle" />
                  <p class="step-label">Registered</p>
                </li>
                <li :class="['dots', {active: tracking.data.status.dispatched, checked: tracking.data.status.delivered}]" />
                <li :class="['step', {active: tracking.data.status.dispatched, checked: tracking.data.status.delivered}]">
                  <div class="step-circle" />
                  <p class="step-label">On the way</p>
                </li>
                <li :class="['dots', {active: tracking.data.status.delivered, checked: tracking.data.status.delivered}]" />
                <li :class="['step', {active: tracking.data.status.delivered, checked: tracking.data.status.delivered, delivered: tracking.data.status.delivered}]">
                  <div class="step-circle" />
                  <p class="step-label">Delivered</p>
                </li>
              </ul>
            </div>
            <div v-if="!tracking.data.status.error" class="row shipment">
              <div class="expandable" v-if="tracking.data.expanded">
                <ul class="detail">
                  <li v-for="(item, index) in tracking.data.detail" :key="index" class="detail-item">
                    <p class="bold">{{ item.label }}:</p>
                    <p>{{ item.value }}</p>
                  </li>
                </ul>
                <ul :class="['event', {cancelled: tracking.data.status.cancelled, delivered: tracking.data.status.delivered}]">
                  <li v-for="(item, index) in tracking.data.event" :key="index" class="event-item">
                    <p class="bold">{{ item.datetime }}<span>{{ item.location ? ' - ' + item.location : '' }}</span></p>
                    <div class="description">
                      <span v-html="item.description" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div v-if="tracking.data.detail.length && !tracking.data.status.error" class="card-footer toggle" @click="tracking.data.expanded = !tracking.data.expanded">
            <p class="bold">
              <span v-show="!tracking.data.expanded">Show details</span>
              <span v-show="tracking.data.expanded">Hide details</span>
            </p>
          </div>
        </div>
        <div v-else class="card">
          <div class="card-header">
            <h2>Tracking</h2>
          </div>
          <div class="card-body">
            <div class="flex-column">
              <form @submit.prevent="TrackNTrace">
                <div class="label">
                  <span class="label-text">
                    Shipping agent
                  </span>
                  <v-select name="tracking-agent" class="notranslate" v-model="tracking.agent" :options="tracking.option" :clearable="false" :required="true">
                    <template #search="{attributes, events}">
                      <input class="vs__search" v-bind="attributes" v-on="events" :required="!tracking.agent.code">
                    </template>
                    <template slot="option" slot-scope="option">
                      <span class="courier" :class="option.code">
                        {{ option.label }}
                      </span>
                    </template>
                  </v-select>
                </div>
                <div class="label">
                  <span class="label-text">
                    Tracking code
                  </span>
                  <input class="v-input" name="tracking-code" required v-model="tracking.code" @keydown.enter="$event.target.blur(); $event.target.closest('form').querySelector('[type=submit]').click()" @blur="TrackingCode">
                </div>
                <button type="submit" class="button green">Trace</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <ul>
        <li />
        <li>
          © PackShip {{ year }}
        </li>
        <li />
      </ul>
    </footer>
    <div class="loading" v-if="loading">
      <div class="loading-element">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <Messages />
  </main>
</template>

<script>
  import Messages from '@/components/snippets/Messages';
  import { Tool } from '@/helpers/Tool';
  import { BPA }  from '@/helpers/BPA';

  import countries from '../../public/countries.json';
  
  export default {
    name: 'Tracking',
    mixins: [Tool, BPA],
    components: {
      Messages
    },
    data() {
      return {
        ready: false,
        loading: false,
        tracking: {
          success: false,
          agent: {label: ''},
          code: '',
          option: [
            {code: 'bring', label: 'Bring'},
            {code: 'dao', label: 'DAO'},
            {code: 'gls', label: 'GLS'},
            {code: 'pdk', label: 'PostNord'}
          ],
          data: {
            status: {
              registered: false,
              dispatched: false,
              cancelled: false,
              delivered: false,
              error: false,
              message: ''
            },
            expanded: false,
            detail: [],
            event: []
          }
        }
      }
    },
    created() {

    },
    async mounted() {
      this.HandleLabelStatus();
      //if (!await this.HandleLabelStatus()) return;
      const script = () => document.createElement('script');
      const g00gle = {script: {init: script(), translate: script()}};
      g00gle.script.init.innerHTML = `googleTranslateElementInit = () => {
        new google.translate.TranslateElement({pageLanguage: ''}, 'google_translate_element');
        const select = document.querySelector('#google_translate_element select');
        if (select) {
          select.ready = () => {
            let counter = 0;
            return new Promise((resolve, reject) => {
              const check = () => {
                clearTimeout(select.timer);
                if (select.options.length < 109) {
                  if (counter >= 1000) return reject();
                  counter++;
                  return select.timer = setTimeout(check);
                }
                resolve(Array.from(select.options));
              }
              check();
            }).catch(error => error);
          }
          select.ready().then(options => {
            const lang = '${this.lang}';
            select.value = lang || 'da';
            select.dispatchEvent(new Event('change'));
          });
        }
      }`;
      g00gle.script.translate.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      for (let script of Object.values(g00gle.script)) document.head.appendChild(script);
    },
    destroyed() {

    },
    computed: {
      company() {
        return BPA.util.GetCompany();
      },
      year() {
        return new Date().getFullYear();
      },
      URLSearchParams() {
        return new URLSearchParams(window.location.search);
      },
      lang() {
        let ref = this.URLParam('ref');
        let lang = this.URLParam('lang');
        if (this.company == 'klubklub') {
          if (lang) return ['en', 'da'].includes(lang) ? lang : 'da';
          if (ref) switch (ref) {
            case '20': return 'en';
            case '10': return 'da';
            default: return 'da';
          }
        }
        if (this.company == 'beautycos') {
          if (lang) return ['no', 'sv', 'de', 'en', 'da'].includes(lang) ? lang : 'da';
          if (ref) switch (ref) {
            case '55': return 'no';
            case '44': return 'sv';
            case '33': return 'de';
            case '22': return 'en';
            case '11': return 'da';
            default: return 'da';
          }
        }
        return null;
      }
    },
    watch: {

    },
    methods: {
      DateFormat(date) {
        return Tool.DateFormat(date);
      },
      DateToISO(date) {
        return Tool.DateToISO(date);
      },
      NumberFormat(number) {
        return Tool.NumberFormat(number);
      },
      CloneObject(object = {}) {
        return Tool.CloneObject(object);
      },
      URLParam(param) {
        if (param) return this.URLSearchParams.get(param);
      },
      URLParams(params = []) {
        return params.map(param => this.URLParam(param));
      },
      Capitalize(string) {
        if (string) return Tool.Capitalize(string);
      },
      TitleCase(string) {
        if (string) return Tool.TitleCase(string);
      },
      Trim(e) {
        if (typeof e == 'string') {
          return String(e).trim();
        }
        if (typeof e == 'object' && e.target) {
          const element = e.target;
          const prop = 'value' || 'textContent';
          const text = element[prop];
          element[prop] = String(text).trim();
          return element[prop];
        }
      },
      CapitalizeFirstLetter(e) {
        if (typeof e == 'string') {
          return String(e.charAt(0).toUpperCase() + e.slice(1)).replace(/\s\s+/g, ' ');
        }
        if (typeof e == 'object' && e.target) {
          const element = e.target;
          const prop = 'value' || 'textContent';
          const text = element[prop];
          element[prop] = String(text.charAt(0).toUpperCase() + text.slice(1)).replace(/\s\s+/g, ' ');
          return element[prop];
        }
      },
      async GetLabelStatus() {
        const options = this.tracking.option;
        const agent = () => {
          let agent = this.URLParam('agent');
          agent = options.find(o => o.code == agent);
          return agent || {label: ''};
        }
        const unsuccessful = () => {
          const code = this.URLParam('code');
          this.tracking.code = code || '';
          this.tracking.agent = agent();
          this.tracking.success = false;
          this.ready = true;
        }
        return await new Promise((resolve, reject) => {
          const param = {keys: ['agent', 'code']};
          param.values = this.URLParams(param.keys);
          if (!param.values.filter(e => e).length) {
            return unsuccessful();
          }
          for (let i = 0; i < param.keys.length; i++) {
            const key = param.keys[i];
            let value = param.values[i];
            if (!value) {
              unsuccessful();
              return reject();
            }
            this.tracking[key] = key == 'agent' ? agent() : value;
          }
          this.loading = true;
          BPA.api.GetLabelStatus(param.values).then(response => {
            return BPA.api.response({response, return: 'json', 
              error: (message) => {
                if (response.status == 424) {
                  return resolve(message);
                }
                reject(message);
                this.$eventHub.$emit('ShowMessages', {
                  message: message,
                  type: 'error',
                  close: true
                });
              }
            });
          }).then(response => {
            this.loading = false;
            if (!response.ok) return reject();
            resolve(response.result);
          }).catch(unsuccessful);
        }).catch(e => e);
      },
      async HandleLabelStatus() {
        return await new Promise(async (resolve, reject) => {
          let data = await this.GetLabelStatus();
          this.ready = true;
          if (!data) {
            this.success = false;
            return reject();
          }
          if (typeof data == 'string') {
            let json = data.match(/{([^}]+)}/);
            if (json) data = JSON.parse(json[0]);
            this.tracking.data.status.error = true;
          }
          data = JSON.parse(JSON.stringify(data));
          let loaded = false;
          switch (this.tracking.agent.code) {
            case 'bring':
              loaded = await this.Bring(data);
              break;
            case 'dao':
              loaded = await this.DAO(data);
              break;
            case 'gls':
              loaded = await this.GLS(data);
              break;
            case 'pdk':
              loaded = await this.PostNord(data);
          }
          if (!loaded) return reject();
          this.tracking.success = true;
          return resolve(true);
        }).catch(e => e);
      },
      IsObject(x) {
        return x instanceof Object || typeof x == 'object';
      },
      IsString(x) {
        return x instanceof String || typeof x == 'string';
      },
      async Bring(data) {
        return await new Promise((resolve, reject) => {
          if (this.IsObject(data)) {
            data = data?.consignmentSet?.[0] || {};
            if (data.hasOwnProperty('error')) {
              this.tracking.data.status.error = true;
              this.tracking.data.status.message = data.error.message;
              return reject();
            }
            const tracking = {detail: [], event: [], status: {}};
            const address = {
              sender: data.senderAddress,
              recipient: data.recipientAddress
            };
            const parcel = data.packageSet[0];
            const events = parcel.eventSet;
            const eventStatus = (status = []) => {
              if (!status.length) return false;
              return events.some(e => status.includes(e.status));
            }
            const regex = {
              html: new RegExp('(<([^>]+)>)', 'ig'),
              email: new RegExp(` til ${parcel.recipientEmailAddress}`, 'ig'),
              mobile: new RegExp(` til \\${parcel.recipientMobileNumber}`, 'ig')
            }
            const sender = {
              label: 'Sender',
              value: data.senderName
            };
            const recipient = {
              label: 'Recipient',
              value: `${address.recipient.postalCode} ${address.recipient.city}`
            };
            if (address.sender.country != address.recipient.country) {
              if (address.sender.country && address.recipient.country) {
                sender.value += `, ${address.sender.country}`;
                recipient.value += `, ${address.recipient.country}`;
              }
            }
            tracking.detail = [sender, recipient, {
              label: 'Delivery',
              value: parcel.productName
            }, {
              label: 'Width',
              value: `${parcel.widthInCm} cm`
            }, {
              label: 'Height',
              value: `${parcel.heightInCm} cm`
            }, {
              label: 'Length',
              value: `${parcel.lengthInCm} cm`
            }, {
              label: 'Weight',
              value: `${parcel.weightInKgs} kg`
            }];
            for (let event of events) {
              let datetime = Tool.DateToUTC(event.dateIso);
              let location = `${event.city} ${event.countryCode}`;
              let description = event.description;
              for (let key in regex) {
                let filter = ['email', 'mobile'].includes(key) ? '.' : '';
                description = description.replace(regex[key], filter);
              }
              tracking.event.push({
                datetime: datetime,
                location: location.trim(),
                description: description.trim()
              });
            }
            tracking.status.registered = eventStatus(['PRE_NOTIFIED']);
            tracking.status.dispatched = eventStatus(['IN_TRANSIT', 'TRANSPORT_TO_RECIPIENT']);
            tracking.status.delivered = eventStatus(['READY_FOR_PICKUP', 'DELIVERED']);
            if (tracking.status.registered) {
              tracking.status.message = 'The parcel is registered';
            }
            if (tracking.status.dispatched) {
              tracking.status.message = 'The parcel is on the way';
            }
            if (tracking.status.delivered) {
              if (eventStatus(['READY_FOR_PICKUP'])) {
                tracking.status.message = 'The parcel is ready for pickup';
              }
              if (eventStatus(['DELIVERED'])) {
                tracking.status.message = 'The parcel is delivered';
              }
            }
            for (let key in tracking.status) {
              this.tracking.data.status[key] = tracking.status[key];
            }
            this.tracking.data.detail = tracking.detail;
            this.tracking.data.event = tracking.event;
            //console.log('Bring', this.CloneObject(data))
            return resolve(data);
          }
          return reject();
        }).catch(e => e);
      },
      async DAO(data) {
        return await new Promise((resolve, reject) => {
          if (this.IsString(data)) {
            let message = data.match(/\D+(?![^:]*:)/g);
            message = (message ? message[0] : '').replace(/^: /, '');
            this.tracking.data.status.message = message;
            return reject();
          }
          if (this.IsObject(data)) {
            const tracking = {detail: [], event: [], status: {}};
            const country = data.modtager.land || '';
            const events = data.haendelser || [];
            const abroad = events.some(e => e.haendelse == 60);
            const link = {regex: new RegExp('(http|ftp|https)://([\\w_-]+(?:(?:\\.[\\w_-]+)+))([\\w.,@?^=%&:/~+#-]*[\\w@?^=%&/~+#-])?(.*\\s)', 'ig')};
            const eventStatus = (status = '') => {
              if (!status) return false;
              status = new RegExp(status, 'ig');
              return events.some(e => status.test(e.beskrivelse || e.sted));
            }
            const sender = {
              label: 'Sender',
              value: data.afsender
            };
            const recipient = {
              label: 'Recipient',
              value: data.modtager.post
            };
            const denmark = 'Danmark';
            if (abroad) {
              sender.value += `, ${countries[denmark]}`;
              recipient.value += `, ${countries[country]}`;
            }
            tracking.detail = [sender, recipient];
            for (let event of events.reverse()) {
              let datetime = event.tidspunkt || '';
              let location = event.sted;
              let description = this.Capitalize(event.beskrivelse);
              if (!location) {
                if (event.haendelse != 60) {
                  location = countries[denmark];
                }
              }
              if (!description) {
                description = location;
                location = country;
                if (abroad) {
                  location = countries[country];
                }
              }
              description = description.replace(/ - , /g, ' - ');
              description = description.replace(/\. - /g, ' - ');
              description = description.replace(/ - ,$/g, '');
              description = description.replace(/_/g, ' ');
              description = description.replace(/,$/g, '');
              link.match = description.match(link.regex);
              if (link.match) {
                link.match = link.match[0];
                link.href = link.match.replace(' ', '_').trim();
                link.next = {regex: new RegExp(`(${link.match.replace(/\//g, '\\/').replace(/\./g, '\\.').replace('?', '\\?')})(.*$)`)}
                link.next.match = description.match(link.next.regex) || [];
                if (link.next.match.length == 3) {
                  link.text = link.next.match[2];
                  link.anchor = `<a href="${link.href}" target="_blank">${link.text}</a>`;
                  description = description.replace(link.next.match[0], link.anchor);
                }
              }
              tracking.event.push({
                datetime: datetime,
                location: location.trim(),
                description: description.trim()
              });
            }
            if (events.length) {
              if (events[0].pakketype) {
                tracking.detail.push({
                  label: 'Delivery',
                value: events[0].pakketype
                });
              }
            }
            if (data.afhentningssted) {
              tracking.detail.push({
                label: 'Pickup',
                value: data.afhentningssted.navn
              });
            }
            if (data.eta) {
              tracking.detail.push({
                label: 'Expected',
                value: data.eta
              });
            }
            tracking.status.registered = !!events.length;
            tracking.status.dispatched = eventStatus('shipped|levering|omdirigeret|leveret');
            tracking.status.delivered = eventStatus('delivered|leveret');
            tracking.status.cancelled = eventStatus('annulleret');
            if (tracking.status.registered) {
              tracking.status.message = 'The parcel is registered';
            }
            if (tracking.status.dispatched) {
              tracking.status.message = 'The parcel is on the way';
            }
            if (tracking.status.delivered) {
              if (eventStatus('afhentning')) {
                tracking.status.message = 'The parcel is ready for pickup';
              }
              if (eventStatus('delivered|leveret')) {
                tracking.status.message = 'The parcel is delivered';
              }
            }
            if (tracking.status.cancelled) {
              tracking.status.message = 'The parcel is cancelled';
            }
            for (let key in tracking.status) {
              this.tracking.data.status[key] = tracking.status[key];
            }
            this.tracking.data.detail = tracking.detail;
            this.tracking.data.event = tracking.event;
            //console.log('DAO', this.CloneObject(data))
            return resolve(data);
          }
          return reject();
        }).catch(e => e);
      },
      async GLS(data) {
        return await new Promise((resolve, reject) => {
          if (this.IsObject(data)) {
            if (data.hasOwnProperty('lastError')) {
              this.tracking.data.status.error = true;
              let message = data.exceptionText.replace(/<br>/g, '\n');
              this.tracking.data.status.message = message;
              return reject();
            }
            data = data?.tuStatus?.[0] || {};
            const tracking = {detail: [], event: [], status: {}};
            const parcel = data.infos;
            const events = data.history;
            const status = data.progressBar.statusInfo;
            for (let detail of parcel.reverse()) {
              if (/services/ig.test(detail.name)) {
                detail.name = 'Delivery';
              }
              tracking.detail.push({
                label: detail.name.replace(':', ''),
                value: detail.value.split(',')[0]
              });
            }
            for (let event of events) {
              let datetime = `${event.date} ${event.time}`;
              let location = `${event.address.city} ${event.address.countryName}`;
              let description = event.evtDscr;
              tracking.event.push({
                datetime: datetime,
                location: location.trim(),
                description: description.trim()
              });
            }
            if (status == 'PREADVICE') {
              tracking.status.registered = true;
              tracking.status.message = 'The parcel is registered';
            }
            if (['INTRANSIT', 'INWAREHOUSE', 'INDELIVERY'].includes(status)) {
              tracking.status.registered = true;
              tracking.status.dispatched = true;
              tracking.status.message = 'The parcel is on the way';
            }
            if (status == 'DELIVERED') {
              tracking.status.registered = true;
              tracking.status.dispatched = true;
              tracking.status.delivered = true;
              tracking.status.message = 'The parcel is delivered';
            }
            for (let key in tracking.status) {
              this.tracking.data.status[key] = tracking.status[key];
            }
            this.tracking.data.detail = tracking.detail;
            this.tracking.data.event = tracking.event;
            //console.log('GLS', this.CloneObject(data))
            return resolve(data);
          }
          return reject();
        }).catch(e => e);
      },
      async PostNord(data) {
        return await new Promise((resolve, reject) => {
          if (this.IsObject(data)) {
            data = data.TrackingInformationResponse.shipments[0];
            if (!data) {
              this.tracking.data.status.error = true;
              let message = 'No shipment found.\nEither your shipment is not traceable or you entered an incorrect shipment ID.';
              this.tracking.data.status.message = message;
              return reject();
            }
            const tracking = {detail: [], event: [], status: {}};
            const consignor = data.consignor.address;
            const consignee = data.consignee.address;
            const items = data.items[0];
            const parcel = {...items, ...items.statedMeasurement};
            const events = this.CloneObject(parcel.events);
            const eventStatus = (status = []) => {
              if (!status.length) return false;
              return events.some(e => status.includes(e.status));
            }
            let sender = {
              label: 'Sender',
              value: data.consignor.name
            };
            let recipient = {
              label: 'Recipient',
              value: `${consignee.postCode} ${consignee.city}`
            };
            if (consignor.country != consignee.country) {
              sender.value += `, ${consignor.country}`;
              recipient.value += `, ${consignee.country}`;
            }
            tracking.detail = [sender, recipient, {
              label: 'Delivery',
              value: data.service.name
            }];
            if (items.statedMeasurement) {
              tracking.detail.push({
                label: 'Width',
                value: `${parcel.width.value} ${parcel.width.unit}`
              }, {
                label: 'Height',
                value: `${parcel.height.value} ${parcel.height.unit}`
              }, {
                label: 'Length',
                value: `${parcel.length.value} ${parcel.length.unit}`
              }, {
                label: 'Weight',
                value: `${parcel.weight.value} ${parcel.weight.unit}`
              });
            }
            if (parcel.estimatedTimeOfArrival) {
              tracking.detail.push({
                label: 'Expected',
                value: this.DateToISO(parcel.estimatedTimeOfArrival)
              });
            }          
            for (let event of events.reverse()) {
              event = {...event, ...event.location};
              let datetime = Tool.DateToUTC(event.eventTime);
              let description = event.eventDescription;
              let location = '';
              let postcode = Number(event.postcode);
              if (postcode) location = `${event.postcode} `;
              if (postcode && event.city && event.city != event.name) {
                location += `${event.city} - `;
              }
              if (event.displayName) {
                location += event.displayName;
              } else {
                let locationType = event.locationType.replace(/_/g, ' ');
                location += `${locationType} - ${event.country}`;
              }
              tracking.event.push({
                datetime: datetime,
                location: location.trim(),
                description: description.trim()
              });
            }
            tracking.status.registered = eventStatus(['CREATED', 'INFORMED']);
            tracking.status.dispatched = eventStatus(['EN_ROUTE', 'OTHER']);
            tracking.status.delivered = eventStatus(['AVAILABLE_FOR_DELIVERY', 'DELIVERED']);
            if (tracking.status.registered) {
              tracking.status.message = 'The parcel is registered';
            }
            if (tracking.status.dispatched) {
              tracking.status.message = 'The parcel is on the way';
            }
            if (tracking.status.delivered) {
              if (eventStatus(['AVAILABLE_FOR_DELIVERY'])) {
                tracking.status.message = 'The parcel is ready for pickup';
              }
              if (eventStatus(['DELIVERED'])) {
                tracking.status.message = 'The parcel is delivered';
              }
            }
            for (let key in tracking.status) {
              this.tracking.data.status[key] = tracking.status[key];
            }
            this.tracking.data.detail = tracking.detail;
            this.tracking.data.event = tracking.event;
            //console.log('PostNord', this.CloneObject(data))
            return resolve(data);
          }
          return reject();
        }).catch(e => e);
      },
      Translate() {

      },
      TrackingCode(event) {
        let value = event.target.value;
        value = String(value).toUpperCase().replace(/\s+/g, '');
        this.tracking.code = value;
      },
      TrackNTrace() {
        if (!this.tracking.agent.code) return;
        const url = new URL(BPA.host + this.$route.path);
        url.searchParams.set('agent', this.tracking.agent.code);
        url.searchParams.append('code', this.tracking.code);
        window.location.search = url.searchParams;
      },
      CompanyLogoURL() {
        return BPA.util.GetCompanyLogo(this.company);
      },
      CompanyWebsiteURL() {
        let site_url = `https://${this.company}.`;
        switch (this.lang) {
          case 'no':
            site_url += 'no';
            break;
          case 'sv':
            site_url += 'se';
            break;
          case 'de':
            site_url += 'de';
            break;
          case 'en':
            site_url += 'co.uk';
            break;
          default:
            site_url += 'dk';
        }
        return site_url;
      },
      AgentLogoURL(agent_code = this.tracking.agent.code) {
        let svg_url = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" ';
        switch (agent_code) {
          case 'bring':
            svg_url += 'height="150.656" viewBox="-132.639 124.543 400 150.656"%3E%3Cpath fill="%237BC144" d="M132.124 187.743h13.599v-13.432h-13.599v13.432zm0 63.199h13.599v-57.933h-13.599v57.933zm106.944-12.123c-10.107 0-12.154-3.69-12.154-17.237 0-13.552 2.047-17.713 12.154-17.713 11.676 0 14.811 3.207 14.811 17.707 0 14.498-3.135 17.234-14.811 17.234v.009zm16.011-45.813v4.567c-4.572-4.039-12.033-5.589-18.296-5.589-20.221 0-23.468 12.007-23.468 29.598 0 13.906 1.319 29.354 23.587 29.354 5.657 0 12.639-1.305 16.854-5.114 0 2.969.122 7.155-.237 10.125-.726 5.462-6.385 7.846-14.208 7.846-7.585 0-9.979-2.116-9.979-6.274h-14.816c0 14.738 13.36 17.681 25.155 17.681 10.836 0 25.043-2.85 27.209-16.637.481-3.207.481-8.458.481-13.808v-51.746h-12.282v-.003zm-71.762-1.022c-8.302 0-13.599 2.614-16.968 5.589v-4.572H154.56v57.936h13.598v-26.982c0-10.099-1.078-20.085 13.604-20.085 11.801 0 10.717 5.344 10.717 16.521v30.546h13.599v-31.621c0-12.59.969-27.334-22.752-27.334l-.009.002zm-76.732 0c-6.865 0-12.281 2.139-16.132 6.185v-5.165H78.657v57.933h13.599v-25.199c0-4.515-.237-10.934 1.328-15.095 1.444-3.917 4.936-6.886 10.595-6.886 5.66 0 7.904 1.186 7.904 6.535h13.523c0-12.719-6.379-18.308-19.019-18.308h-.002zm-60.854 47.789c-11.681 0-15.054-3.213-15.054-17.71 0-14.509 3.374-17.713 15.054-17.713 10.109 0 12.273 4.155 12.273 17.713 0 13.547-2.167 17.704-12.273 17.704v.006zm3.004-47.786c-6.377 0-13.36.713-17.814 5.235v-22.951H17.322v76.665h12.272v-4.633c3.616 3.206 9.157 5.584 16.982 5.584 23.469 0 25.03-15.687 25.03-29.824 0-17.594-2.762-30.079-22.869-30.079l-.002.003z"/%3E%3Cpath fill="%23C1C1C1" d="M-94.032 223.293c-17.517 0-31.864-13.338-33.224-30.284h-5.383c1.402 35.137 30.679 63.199 66.611 63.199 23.603 0 44.337-12.114 56.18-30.387A64.92 64.92 0 00.583 193.009h-61.395c-1.36 16.946-15.707 30.284-33.224 30.284h.004z"/%3E%3Cpath fill="%237BC144" d="M-127.256 187.74c1.36-16.945 15.707-30.285 33.224-30.285 17.511 0 31.858 13.34 33.224 30.285H.583c-1.405-35.139-30.682-63.197-66.611-63.197-35.932 0-65.207 28.058-66.611 63.197h5.383"/%3E%3C/svg%3E';
            break;
          case 'dao':
            svg_url += 'height="204.99" viewBox="0 97.505 400 204.99"%3E%3Cpath fill="%23E30613" d="M375.413 181.198c-8.968-4.966-28.348-5.207-38.762-5.207-10.413 0-29.794.241-38.761 5.207-23.382 12.775-24.587 40.882-24.587 57.9 0 17.259 1.205 45.414 24.587 58.142 8.967 4.965 28.348 5.207 38.761 5.207 10.414 0 29.794-.242 38.762-5.207C398.795 284.465 400 256.357 400 239.099c0-16.97-1.157-45.125-24.587-57.901m-26.468 83.693c-3.085 1.64-8.726 1.881-12.294 1.881-3.567 0-9.208-.241-12.293-1.881-5.689-3.326-5.93-14.896-5.93-25.984 0-10.896.24-21.984 5.93-25.311 3.085-1.64 8.726-1.881 12.293-1.881 3.568 0 9.209.241 12.294 1.881 5.688 3.326 5.93 14.414 5.93 25.311 0 11.087-.241 22.706-5.93 25.984zm-222.249-88.948V97.505h-24.587c-12.824 0-20.538 12.873-20.538 25.359v53.658c-6.123-.434-13.836-.482-18.224-.482-10.414 0-29.794.241-38.761 5.207C1.205 193.974 0 222.129 0 239.146c0 17.26 1.205 45.414 24.587 58.142 8.967 4.966 28.347 5.207 38.761 5.207s29.794-.241 38.761-5.207c23.382-12.775 24.587-40.882 24.587-58.142 0-2.362-.048-4.918-.145-7.617l.145-55.586m-51.054 88.948c-3.085 1.64-8.726 1.881-12.293 1.881s-9.208-.241-12.293-1.881c-5.689-3.326-5.93-14.896-5.93-25.984 0-10.896.241-21.984 5.93-25.311 3.085-1.64 8.726-1.881 12.293-1.881s9.208.241 12.293 1.881c5.689 3.326 5.93 14.414 5.93 25.311 0 11.087-.241 22.706-5.93 25.984zm187.2-52.019c0-19.862-16.729-36.351-38.23-36.351h-25.166c-10.414 0-29.794-.241-38.761 4.725-23.382 12.776-24.587 40.883-24.587 57.9 0 17.26 1.206 45.414 24.587 58.142 7.328 4.05 19.573 5.015 30.228 5.207 25.599.048 26.756-23.237 26.756-23.237 0 8.918 7.569 23.237 21.743 23.237h23.382l.048-76.51v-13.113m-51.103 52.019c-3.085 1.64-8.726 1.881-12.293 1.881s-9.208-.241-12.294-1.881c-5.688-3.326-5.93-14.896-5.93-25.984 0-10.896.241-21.984 5.93-25.311 3.085-1.64 8.726-1.881 12.294-1.881s9.208.241 12.293 1.881c5.688 3.326 5.93 14.414 5.93 25.311 0 11.087-.241 22.706-5.93 25.984z"/%3E%3C/svg%3E';
            break;
          case 'dpd':
            svg_url += 'height="168.495" viewBox="-130.491 -54.967 400 168.495"%3E%3Cpath fill="%233F3F42" d="M252.594-7.147v28.314c-2.765-1.381-7.252-1.9-11.739-1.9-19.338 0-32.629 12.603-32.629 32.111 0 20.543 14.328 31.766 35.736 31.766 8.458 0 18.124-.865 25.547-2.937V-7.147h-16.915zm0 75.443c-2.765.691-5.872.691-7.94.691-11.914 0-19.338-6.561-19.338-18.129 0-10.874 6.732-17.09 17.09-17.09 4.145 0 7.598.691 10.188 1.899v32.629zm-49.721-18.301c0 21.234-12.948 33.148-34.699 33.148h-.865v-14.33c10.531-.175 18.472-5.87 18.472-18.298 0-10.531-7.078-16.401-17.435-16.401-3.279 0-7.253.346-10.012 1.554v70.781h-16.921V24.445c6.732-2.762 16.921-5.179 27.277-5.179 20.373.001 34.183 11.395 34.183 30.729zm-87.699-28.828c-2.765-1.381-7.424-1.9-11.739-1.9-19.338 0-32.63 12.603-32.63 32.111 0 20.543 14.157 31.766 35.737 31.766 8.283 0 17.952-.865 25.376-2.937V-7.147h-16.744v28.314zm0 47.129c-2.765.691-6.044.691-8.115.691-11.913 0-19.163-6.561-19.163-18.129 0-10.874 6.732-17.09 16.919-17.09 4.145 0 7.769.691 10.359 1.899v32.629z"/%3E%3Cpath fill="%23DC0032" d="M16.251-5.075l-1.486.945-.068-.083-1.898 1.208.01.011-1.564.854.008.01-1.562.852.009.01-1.563.854.009.011-1.563.852.052.06-1.605.803.064.076-1.446.788.009.011-1.562.852.01.011-1.564.852.01.011-1.564.852.01.011-1.564.851.01.011-1.562.853.063.074-1.446.789.027.031-1.165.742-.07-.082-1.484.945-.07-.082-1.485.945-.069-.082-1.482.944-.07-.082-1.373.873-.009-.01-1.899 1.209.009.011-1.563.852.008.011-1.562.852.01.011-1.564.853.009.011-1.563.852.01.011-1.563.853.064.075-1.446.788.01.011-1.563.852.01.011-1.562.853.024.028-1.061.662c-.045 0-.09.028-.135.045l-.038-.045c-.629.316-1.524.306-2.204.045l-.04-.045h-.173l-.862-.69.293.344-3.401-2.071c-.346-.173-.519-.519-.864-.863-.344-.518-.344-.864-.517-1.209v-4.659c0-.419.239-.933.505-1.394l.011.012c.173-.345.346-.518.691-.691l.628-.419.062.073 1.373-.873.008.01 1.484-.944.07.082 1.483-.946.07.082 1.483-.944.07.081 1.899-1.208-.01-.011 1.564-.853-.006-.011 1.563-.851-.064-.075 1.445-.79-.01-.011 1.564-.851-.01-.011 1.563-.852-.008-.01 1.562-.854-.008-.01 1.563-.853-.009-.01 1.563-.854-.052-.061 1.606-.802-.064-.074 1.446-.788-.01-.011 1.563-.853-.01-.011 1.563-.851-.026-.031 1.165-.742.07.082 1.373-.873.008.01 1.529-.891.022.028 1.485-.944.069.08 1.899-1.208-.008-.01 1.562-.853-.01-.011 1.564-.853-.008-.011 1.563-.851-.053-.061 1.604-.802L6-14.3l1.446-.789-.009-.01L9-15.951l-.008-.01 1.562-.854-.008-.011 1.563-.851-.011-.013 1.219-.679-3.247-1.689-.033-.036-4.088-2.181-.055-.064-4.291-2.214-.025-.029-4.09-2.181-.055-.064-4.09-2.182-.053-.062-4.29-2.215-.026-.031-4.09-2.181-.053-.063-4.09-2.182-.054-.062-4.289-2.214-.027-.031-4.09-2.182-.053-.062-3.978-2.052-.166-.193-4.291-2.215-.025-.028-4.087-2.18-.056-.065-5.352-2.933.045.052-4.189-2.297.218.254-3.27-1.743-.055-.065-1.036-.517c-.694-.416-1.41-.572-2.194-.632l-.05-.059h-.519c-.504 0-1.009.101-1.513.218l-.04-.045c-.074.037-.166.074-.25.111-.09.022-.18.04-.268.062l.035.042c-.233.101-.453.202-.554.304l-.586.292-.104-.121-1.899 1.037.01.011-1.563.852.01.011-1.564.851.01.011-1.564.853.01.011-1.126.614-.091-.106-1.484.944-.07-.082-1.898 1.036.008.01-1.562.854.008.01-1.563.853.009.01-1.563.853.01.011-1.125.614-.093-.107-2.072 1.036.052.061-1.606.804.052.06-1.606.802.052.061-1.605.804.052.061-1.604.802.052.06-1.037.517-.052-.061-2.071 1.037.052.061-1.606.802.052.061-1.606.802.01.011-1.563.853.008.011-1.563.851.01.011-1.126.614-.091-.107-1.899 1.036.01.011-1.564.853.009.011-1.563.852.008.011-1.562.852.01.011-1.564.853.009.011-1.124.614-.093-.108-1.898 1.037.008.01-1.563.853.01.011-1.564.853.01.011-1.563.851.01.011-1.563.852.01.011-1.127.614-.091-.106-1.899 1.035.01.011-1.563.853.01.011-1.564.852.01.011-1.563.851.01.011-1.562.853.008.01-1.125.614-.093-.106-2.071 1.037.069.084-.76.433 2.027 1.115.218.266 5.51 3.005 3.455 1.989.011.013 5.526 3.281-.176-.208 3.522 1.982.105.124 4.383 2.466.105.124 5.093 2.865 3.702 2.131.01.011 4.481 2.581.007.008.149.082 1.059.61-.052-.061 3.106 1.694.227.264 4.377 2.463.11.128 5.525 3.106-.129-.152 4.616 2.741-.13-.152 4.619 2.742-.18-.209 3.193 1.797.267.311 4.261 2.324.228.267 4.745 2.587 1.298.865c.581.291 1.137.951 1.307 1.667l-.098-.114c0 .173.173.346.173.519V89.518c0 .2-.062.385-.144.551l-.029-.033c-.016.062-.048.12-.069.183-.035.053-.066.123-.104.163l.031.036c-.195.452-.508.84-.851 1.048l-.044-.051c0 .048-.008.057-.011.082-.053.031-.106.076-.16.093l-1.19.714-.02-.022-1.529.891-.023-.028-1.21.691c-.344.171-.69.171-1.035.171l.092.107c-.098.03-.199.067-.265.067h-.173c-.517 0-.863-.175-1.208-.346l-.319-.144-.025-.028-3.799-2.073c-.69-.346-1.208-1.208-1.208-2.071V33.599c0-.343-.346-.863-.691-1.034l-2.548-1.506-.041-.048-4.479-2.58-.01-.011-.194-.105-1.014-.584.05.059-3.101-1.692-.229-.267-5.526-3.106.129.152-4.617-2.743.134.156-4.623-2.745.18.209-3.194-1.795-.267-.312-5.502-3.001-3.469-1.998-.007-.008-5.524-3.28.18.209-3.523-1.982-.108-.125-5.526-3.107.131.152-4.618-2.741.132.153-3.366-2-.046-.053-.543-.296-.665-.395.052.061-3.106-1.694-.227-.264-1.381-.691V68.805c0 1.115.53 2.346 1.26 3.332l-.225-.225c.143.144.25.281.358.413.367.458.763.871 1.196 1.141l4.002 2.17 3.413 1.967.009.008 4.198 2.417.291.343 4.262 2.323.227.268 5.697 3.281-.132-.154 4.621 2.742-.154-.18 3.595 2.065.011.015 4.481 2.579.007.009 4.48 2.582.008.008 4.48 2.583.008.008 4.525 2.605.135.157 5.525 3.279-.13-.152 4.618 2.742-.16-.188 3.605 2.079.008.008 4.482 2.58.007.008.906.518.302.174-.002-.003 1.211.691c.382.259.945.385 1.496.453l.058.067h1.036c.378 0 .754-.022 1.132-.091l.077.091a354.42 354.42 0 001.554-.521l.517-.343-.01-.011 1.564-.854-.009-.009 1.563-.851-.064-.076 1.445-.79-.008-.011 1.563-.852-.027-.031 1.165-.741.07.081 1.484-.944.07.082 1.484-.944.07.082 1.898-1.209-.064-.075 1.447-.787-.01-.012 1.563-.854-.009-.009 1.563-.854-.01-.011 1.563-.852-.008-.009 1.563-.854-.065-.076 1.446-.787-.01-.011 1.563-.854-.025-.03 1.166-.739.067.078 1.482-.943.072.084 1.374-.874.007.009 1.899-1.209-.009-.011 1.563-.852-.01-.011 1.563-.852-.01-.012 1.564-.854-.009-.009 1.561-.852-.064-.076 1.447-.789-.008-.012 1.561-.851-.027-.031 1.166-.742.07.082 1.484-.944.07.081 1.372-.873.01.011 1.898-1.211-.008-.009 1.562-.852-.01-.011 1.564-.854-.009-.011 1.563-.852-.01-.012 1.563-.851-.063-.073 1.444-.79-.01-.011 1.563-.852-.01-.012 1.563-.854-.025-.028 1.166-.727.069.079 1.371-.871.01.011 1.486-.943.068.078 1.899-1.208-.009-.012 1.563-.851-.01-.012 1.562-.852-.01-.011 1.564-.854-.063-.073 1.444-.786h-.001l1.039-.521.171-.171c.518-.346 1.037-1.037 1.554-1.557l-.073-.085c.352-.548.628-1.096.765-1.641l-.049-.059c.119-.383.222-.768.222-1.149V-5.421l-.667.382-.026-.036z"/%3E%3C/svg%3E';
            break;
          case 'gls':
            svg_url += 'height="107.627" viewBox="0 146.186 400 107.627"%3E%3Cpath fill="%23001652" d="M383.868 184.049c3.732 0 8.999.934 12.266 2L400 165.651c-4.732-.799-9.799-1.333-15.465-1.333-24.599 0-36.131 14.665-36.131 31.13 0 21.466 21.865 21.198 21.865 30.331 0 4.601-3.268 7.133-10.267 7.133-4.732 0-11.531-1.133-15.465-2.601l-4.199 21.999c4.532.866 10.932 1.467 17.465 1.467 21.865 0 37.33-14.6 37.33-32.265 0-20.864-21.998-21.198-21.998-30.464.067-4.065 2.801-6.999 10.733-6.999M307.675 164.384l-17.198 88.926h41.329l4.067-22.199h-18.666l12.999-66.727zM272.678 164.384c-33.864 0-55.528 25.265-55.528 56.329 0 19.399 10.266 32.864 35.997 32.864 10.266 0 20.997-1.8 29.663-5.532l8.267-42.997h-22.664l-4.866 26.197c-2.001.534-4.399.667-6.2.667-11.399 0-15.466-6.333-15.466-14.532 0-15.466 9.466-31.464 28.799-31.464 5.398 0 11.398 1 16.731 2.733.532.133 1.133.333 1.732.466 1.934.667 3.467 1.466 4.733 2l4.533-23.265c-7.799-2.132-17.198-3.466-25.731-3.466"/%3E%3Cpath fill="%23FEBE10" d="M102.892 164.584l-6.066 29.598h41.997C103.958 245.645 34.964 236.979 16.7 215.647c-15.666-18.399-2.133-49.93 44.462-69.461-46.196 13.999-71.994 50.929-56.795 75.727 17.266 28.131 70.995 39.862 118.724 26.197 31.93-11.266 45.463-26.997 50.529-35.463l-7.866 40.862h31.397l17.065-88.925H102.892z"/%3E%3C/svg%3E';
            break;
          case 'pdk':
            if (this.lang == 'de') return this.AgentLogoURL('dpd');
            svg_url += 'height="75.419" viewBox="100.497 19.761 400 75.419"%3E%3Cpath fill="%230498BA" d="M500.463 81.819c-4.874-.321-9.755-.052-14.631-.14-.5-.009-1.006-.053-1.497.011-1.082.14-1.348-.37-1.272-1.348.07-.927.015-1.862.015-3.027-.989.821-1.784 1.557-2.653 2.191-8.148 5.937-21.074 4.543-27.992-3.003-8.648-9.436-8.606-26.592-.105-36.118 7.708-8.635 22.455-9.71 30.17-3.57.111.089.284.099.581.197 0-4.182.064-8.269-.037-12.352-.031-1.248.446-1.596 1.528-1.797 4.629-.862 9.246-1.79 13.868-2.691.266-.052.56-.031.694-.343 1.141-.252 1.368.192 1.365 1.333-.046 20.22-.034 40.439-.034 60.657zM464.47 57.932c-.004 5.802 3.842 9.841 9.396 9.87 5.68.031 9.627-3.981 9.65-9.811.02-5.672-3.936-9.641-9.606-9.639-5.608.003-9.436 3.887-9.44 9.58zM429.198 39.498c3.991-5.372 9.289-6.084 15-5.645 1.038.08 1.54.478 1.493 1.659-.174 4.489-.267 8.98-.345 13.472-.019 1.064-.353 1.336-1.407 1.063a18.173 18.173 0 00-6.109-.5c-5.761.49-8.601 3.529-8.624 9.311-.029 6.995-.045 13.99.023 20.983.014 1.396-.236 1.918-1.788 1.88-4.716-.116-9.437-.069-14.154-.022-1.071.011-1.563-.152-1.559-1.416.045-14.821.039-29.643.007-44.464-.003-1.07.271-1.417 1.379-1.405 4.939.057 9.881.056 14.82 0 1.061-.013 1.35.338 1.281 1.333-.076 1.098-.017 2.206-.017 3.751zM379.271 32.807c5.303.082 9.759.825 14.002 2.643 9.997 4.281 15.256 13.405 14.386 24.271-1.039 12.991-9.878 20.531-21.532 22.728-6.924 1.306-13.723.768-20.235-2.005-10.293-4.382-14.828-13.126-14.289-23.649.771-15.007 11.712-22.057 23.406-23.62 1.645-.22 3.312-.288 4.262-.368zm-9.254 25.21c.001 5.653 4.104 9.804 9.608 9.724 5.587-.082 9.464-4.037 9.469-9.66.005-5.862-3.909-9.889-9.591-9.866-5.596.022-9.489 4.043-9.486 9.802z"/%3E%3Cpath fill="%230598BA" d="M316.588 38.261c5.729-5.589 12.465-6.493 19.693-4.554 6.554 1.759 9.629 6.68 10.847 13.017.326 1.695.427 3.408.425 5.134-.013 9.385-.028 18.771.02 28.156.006 1.25-.244 1.727-1.621 1.701a430.289 430.289 0 00-14.326-.005c-1.292.02-1.698-.315-1.691-1.66.035-7.828-.022-15.657-.069-23.485a12.9 12.9 0 00-.236-2.31c-.809-4.222-2.499-5.626-6.528-5.475-3.878.146-6.246 2.248-6.588 6.12-.386 4.374-.108 8.769-.147 13.154-.036 4.053-.049 8.107.018 12.16.02 1.184-.365 1.505-1.516 1.491a682.385 682.385 0 00-14.661-.001c-1.071.011-1.403-.269-1.4-1.388.038-14.828.042-29.656-.003-44.482-.003-1.238.43-1.431 1.524-1.419 4.775.055 9.553.076 14.327-.009 1.396-.025 1.895.376 1.729 1.761-.079.626-.173 1.309.203 2.094zM263.838 52.67c0-9.11.028-18.219-.031-27.329-.009-1.264.33-1.563 1.563-1.543 4.831.074 9.666.084 14.496-.005 1.327-.024 1.56.436 1.523 1.614-.081 2.553.032 5.111-.05 7.664-.037 1.145.386 1.398 1.44 1.387 4.388-.048 8.776.007 13.164-.038 1.156-.012 1.52.168.874 1.337a792.233 792.233 0 00-6.717 12.442c-.397.75-.879 1.001-1.704.976-1.832-.056-3.671.066-5.497-.045-1.26-.077-1.572.319-1.566 1.566.054 9.61.03 19.218.029 28.829 0 2.152 0 2.153-2.135 2.154-4.555 0-9.11-.057-13.664.033-1.367.027-1.771-.307-1.761-1.715.067-9.108.036-18.217.036-27.327zM240.986 32.858c5.802.199 11.096.647 16.31 1.871 1.096.257 1.306.595 1.032 1.671-.888 3.49-1.721 6.998-2.438 10.526-.268 1.32-.751 1.36-1.894 1.018-5.402-1.615-10.887-2.651-16.565-1.824-.436.063-.863.189-1.287.314-1.042.307-1.856.917-1.844 2.07.013 1.193.938 1.711 1.965 1.944 3.733.846 7.58 1.062 11.294 2.025 1.99.516 3.944 1.121 5.804 2.005 5.147 2.448 7.439 6.453 7.27 12.143-.201 6.739-3.65 11.069-9.642 13.649-4.83 2.079-9.962 2.603-15.132 2.717-6.47.143-12.831-.717-19.07-2.479-1.017-.287-1.292-.606-.99-1.696a286.167 286.167 0 002.83-11.116c.282-1.203.711-1.29 1.793-.873 5.75 2.213 11.671 3.509 17.886 3.046.841-.064 1.657-.213 2.42-.554.857-.383 1.463-.973 1.453-2.022-.01-1.059-.627-1.616-1.516-1.957-1.937-.743-3.993-.906-6.022-1.173-3.527-.465-7.015-1.1-10.329-2.433-9.581-3.854-11.574-16.184-3.719-22.985 4.314-3.735 9.583-4.944 15.051-5.547 1.925-.21 3.872-.249 5.34-.34z"/%3E%3Cpath fill="%230498BA" d="M186.303 32.816c7.271.181 14.066 1.823 19.791 6.608 4.766 3.984 7.212 9.193 7.747 15.316.61 6.993-.677 13.499-5.367 18.988-4.018 4.703-9.265 7.291-15.238 8.544-7.082 1.484-14.022 1.037-20.738-1.712-11.143-4.562-15.557-14.321-14.477-25.267 1.208-12.248 9.817-19.562 21.167-21.776a36.66 36.66 0 017.115-.701zm-.289 15.398c-5.68-.045-9.65 3.923-9.764 9.76-.107 5.485 4.102 9.75 9.627 9.754 5.497.004 9.514-4.023 9.575-9.601.064-5.682-3.922-9.869-9.438-9.913zM100.535 34.494c5.438-.018 10.876-.017 16.314-.073.93-.009 1.126.37 1.083 1.182-.051.938-.012 1.882-.012 2.88.204-.038.398-.015.495-.101 11.496-10.191 29.017-6.123 34.495 8.28 3.903 10.263 3.167 20.218-4.25 28.886-7.825 9.144-22.701 9.58-30.125 3.676-.115-.093-.283-.117-.67-.27v16.195c-5.266 0-10.531-.038-15.797.029-1.181.015-1.575-.158-1.571-1.489.054-19.73.038-39.462.038-59.195zm16.947 23.382c-.074 5.669 3.852 9.761 9.462 9.862 5.351.097 9.497-3.875 9.583-9.182.099-6.138-3.584-10.255-9.253-10.342-5.738-.088-9.715 3.837-9.792 9.662z"/%3E%3C/svg%3E';
        }
        return svg_url;
      },
      AgentTrackingSiteURL() {
        let site_url = 'https://';
        switch (this.tracking.agent.code) {
          case 'bring':
            switch (this.lang) {
              case 'no':
                site_url += 'sporing.posten.no/sporing';
                break;
              case 'sv':
                site_url += 'tracking.bring.se/tracking';
                break;
              case 'da':
                site_url += 'tracking.bring.dk/tracking';
                break;
              default:
                site_url += 'tracking.bring.com/tracking';
            }
            site_url += `/${this.tracking.code}`;
            break;
          case 'burd':
            site_url += `burd.dk/pages/track-and-trace?q=${this.tracking.code}`;
            break;
          case 'dao':
            switch (this.lang) {
              case 'da':
                site_url += 'dao.as/privat/find-din-pakke';
                break;
              default:
                site_url += 'dao.as/en/private/track-your-parcel';
            }
            site_url += `?stregkode=${this.tracking.code}`;
            break;
          case 'gls':
            switch (this.lang) {
              case 'da':
                site_url += 'gls-group.eu/DK/da/find-pakke';
                break;
              case 'de':
                site_url += 'gls-pakete.de/sendungsverfolgung';
                break;
              default:
                site_url += 'gls-group.eu/GROUP/en/parcel-tracking';
            }
            site_url += `?match=${this.tracking.code}`;
            break;
          case 'pdk':
            switch (this.lang) {
              case 'no':
                site_url += 'postnord.no/pakkesporing?shipmentId=';
                break;
              case 'sv':
                site_url += 'postnord.se/vara-verktyg/spara-brev-paket-och-pall?shipmentId=';
                break;
              case 'de':
                site_url += 'tracking.dpd.de/status/de_DE/parcel/';
                break;
              case 'da':
                site_url += 'postnord.dk/varktojer/track-trace?shipmentId=';
                break;
              default:
                site_url += 'postnord.dk/en/tools/track-and-trace?shipmentId='
            }
            site_url += this.tracking.code;
        }
        return site_url;
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
